<template>
    <tr>
        <td class="p-2">
            <select name="prefix"
                    class="form-control"
                    v-model="agent.prefix" >
                <option v-for="(prefix, key) in titles" :value="key">
                    {{ prefix }}
                </option>
            </select>
        </td>
        <td class="p-2">
            <input name="firstName"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': firstNameError}"
                   @input="firstNameError = false"
                   v-model="agent.first_name">
        </td>
        <td class="p-2">
            <input name="lastName"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': lastNameError}"
                   @input="lastNameError = false"
                   v-model="agent.last_name">
        </td>
        <td class="p-2">
            <input name="email"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': emailError}"
                   @input="emailError = false"
                   v-model="agent.email">
        </td>
        <td class="p-2">
            <select name="agentType"
                    class="form-control"
                    v-model="agent.is_master">
                <option value="0">{{ $t('invite.columns.agent') }}</option>
                <option value="1">{{ $t('invite.columns.masterAgent') }}</option>
            </select>
        </td>
        <td class="p-2">
            <button type="button"
                    class="btn btn-outline-danger"
                    :title="$t('invite.deleteRow')"
                    @click="removeAgent">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        name: "new-agent-row",
        props: ['titles', 'agent'],
        data () {
            return {
                firstNameError: false,
                lastNameError: false,
                emailError: false
            }
        },
        methods: {
            removeAgent() {
                this.$emit('agentRemoved', this.agent);
            },
            validate() {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let isValidInvite = true;

                if (this.agent.first_name.trim().length < 1) {
                    this.firstNameError = true;
                    isValidInvite = false;
                }

                if (this.agent.last_name.trim().length < 1) {
                    this.lastNameError = true;
                    isValidInvite = false;
                }

                if (this.agent.email.trim().length < 1 || !re.test(String(this.agent.email.trim()).toLowerCase())) {
                    this.emailError = true;
                    isValidInvite = false;
                }

                return isValidInvite;
            },
            setEmailInvalid() {
                this.emailError = true;
            },
            isEmpty() {
                return (this.agent.first_name.trim().length < 1 && this.agent.last_name.trim().length < 1 && this.agent.email.trim().length < 1);
            },
        }
    }
</script>